import clsx from "clsx";
import type { ButtonHTMLAttributes } from "react";

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> {
  /** What the button does, in words. It is the button's name for screen readers and its tooltip. */
  label: string;
}

/** A round button that holds only an icon. The label is required, so the icon never stands alone. */
export function IconButton({ label, className, type = "button", children, ...rest }: IconButtonProps) {
  return (
    <button type={type} className={clsx("icon-button", className)} aria-label={label} title={label} {...rest}>
      <span aria-hidden="true">{children}</span>
    </button>
  );
}
